import type { Country as CountryType } from '@ps/web-core-intl';
import type { ClassNameProp } from '@ps/web-shared-components';
import React from 'react';

import flags from '@swf/core/assets/flags';
import type { OnClickProp } from '@swf/core/types/Props';

import ListItem from '../../../ListItem/ListItem';

import { flag, flagContainer } from './Country.scss';

interface Props extends Partial<ClassNameProp>, OnClickProp, CountryType, React.PropsWithChildren {
  selected?: boolean;
  disableRipple?: boolean;
}

const Country: React.FC<Props> = ({ value, text, className, ...props }) => (
  <ListItem
    primary={text}
    classes={{ avatar: flag, avatarContainer: flagContainer, selected: className }}
    avatarURL={flags[value]}
    {...props}
  />
);
export default Country;
